'use strict';

import appStore from "@uw-it-sis/lib-react/lib/AppStore";

import Level from "@uw-it-sis/lib-react/lib/FeedbackMessagesLevel";
import feedbackMessagesStore from "@uw-it-sis/lib-react/lib/FeedbackMessagesStore";
import {normalize} from './CourseUtils';

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import { flow, observable, configure, makeObservable } from "mobx";

configure({enforceActions: 'always'});

/**
 * A caching store for course summary data.
 */
class CourseSummaryStore {

    state = States.initial;

    constructor() {
        makeObservable(this, {
            state: observable
        });

        this.baseUrl = 'api/courses';
        this.courseSummaries = {};
    }

    /**
     * Loads a course summary.
     *
     * @param courseCode The course code.
     * @param courseId The id of the course to fetch.
     */
    loadCourseSummary = flow(function* (courseCode, courseId) {
        this.state = States.pending;

        // Check the args.
        if (! courseCode || ! courseId) {
            feedbackMessagesStore.addMessage({level: Level.ERROR, text: "No course id or code was provided."});
            this.state = States.error;
            return;
        }

        // Short circuit if the course has already been fetched.
        if (this.getCourseSummary(normalize(courseCode))) {
            this.state = States.done;
            return;
        }

        const url = `${this.baseUrl}/${encodeURIComponent(courseCode)}?courseId=${encodeURIComponent(courseId)}`;

        try {
            // Store the course in the cache.
            this.courseSummaries[normalize(courseCode)] = yield appStore.getHttpClient().doGet(url, 'get course summary');
            this.state = States.done;
        } catch (error) {
            appStore.getExceptionUtils().handleException(error);
            this.state = States.error;
        }
    }.bind(this));

    /**
     * Gets a particular course summary object for the given course code.
     */
    getCourseSummary(courseCode) {
        let key = normalize(courseCode);
        return this.courseSummaries[key];
    }
}

export default new CourseSummaryStore();